import { Injectable } from '@angular/core';
import { IncidentServiceBase } from '../services/incident-base.service';
import { IncidentConvictionOojModel } from '../models/incident-conviction-ooj.model';

@Injectable()
export class ConvictionIncidentOojService extends IncidentServiceBase<IncidentConvictionOojModel> {
    constructor() {
        super('IncidentConvictionOOJ', () => new IncidentConvictionOojModel());
    }

    public getLookups() {
        return this.get('Incident/IncidentConvictionOOJ/lookups');
    }
}
